import Hook from "../utils/hook"
import { resolveExploreBounds } from "../utils/explore-bounds"

export default Hook(`LocationDebug`, {
  targets: [`boundsStatus`, `boundsValue`, `exploreUrl`],
  values: { exploreBase: String },

  mounted() {
    this.renderBoundsDebug()
  },

  updated() {
    this.renderBoundsDebug()
  },

  renderBoundsDebug() {
    const { locationTrackerLatLng } = window.NaturkartanConfig || {}
    const { bounds, reason, willAddBounds } = resolveExploreBounds(
      locationTrackerLatLng
    )
    const url = new window.URL(this.exploreBaseValue, window.location.origin)

    if (willAddBounds) {
      url.searchParams.set(`bounds`, bounds)
      this.boundsStatusTarget.textContent = `Yes`
      this.boundsValueTarget.textContent = bounds
      this.exploreUrlTarget.textContent = `${url.pathname}${url.search}`
      return
    }

    this.exploreUrlTarget.textContent = `${url.pathname}${url.search}`

    if (reason === `outside_sweden`) {
      this.boundsStatusTarget.textContent = `No, the effective location is outside Sweden.`
      this.boundsValueTarget.textContent = `Not added`
      return
    }

    this.boundsStatusTarget.textContent = `No, there is no effective location.`
    this.boundsValueTarget.textContent = `Not added`
  },
})
